import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { FLOWS } from 'modules/contracts/components/FlowSelectorModal/constants'

interface Props {
  onClose: () => void
  onSubmit: () => void
  targetFullName: string
  actionType: string
}

const ConfirmDeleteRequestModal = ({
  onClose,
  onSubmit,
  targetFullName,
  actionType = FLOWS.promotion,
}: Props) => {
  let title = '',
    description = '',
    submitLabel = ''

  if (actionType === FLOWS.promotion) {
    title = i18n.t('contract_versions.modals.delete_promotion_request.title', {
      targetFullName: targetFullName,
    })
    description = i18n.t('contract_versions.modals.delete_promotion_request.description')
    submitLabel = i18n.t('contract_versions.modals.delete_promotion_request.submit')
  }

  if (actionType === FLOWS.evolution) {
    title = i18n.t('contract_versions.modals.delete_evolution_request.title', {
      targetFullName: targetFullName,
    })
    description = i18n.t('contract_versions.modals.delete_evolution_request.description')
    submitLabel = i18n.t('contract_versions.modals.delete_evolution_request.submit')
  }

  return (
    <Modal
      illustration="alert"
      title={title}
      description={description}
      onClose={onClose}
      onSubmit={() => onSubmit()}
      footer={
        <>
          <Button onClick={onClose} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>{submitLabel}</Button>
        </>
      }
    />
  )
}

export default ConfirmDeleteRequestModal
